<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isMessageDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm">
        <template slot="type">
          <el-radio-group v-model="detailFormData.type" @change="typeChange">
              <el-radio :label="1">推送全部</el-radio>
              <el-radio :label="2">推送居民</el-radio>
          </el-radio-group>
        </template>
        <template slot="userIdList">
          <div class="message-user-wrap">
            <el-button class="message-user-btn" type="primary" size="mini" @click="addUser">添加</el-button>
            <el-table :data="chooseData" style="width: 100%">
              <el-table-column key="nickName" prop="nickName" label="昵称"></el-table-column>
              <el-table-column key="name" prop="name" label="用户名"></el-table-column>
              <el-table-column key="phone" prop="phone" label="手机号"></el-table-column>
              <el-table-column key="communityName" prop="communityName" label="社区"></el-table-column>
              <el-table-column prop="action" label="操作">
                <template slot-scope="data">
                  <wt-auth class="search-form-btn">
                    <el-button style="background: transparent; border: 0; font-weight: bold; color: #F56C6C;" size="mini" type="danger" @click="toClickAction(data.row)">删除</el-button>
                  </wt-auth>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </wt-detail-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="60%"
      :modal="false"
      append-to-body
      :show-close="false"
      :before-close="handleDialogClose">
      <div class="dialog-input-card">
        <wt-form-table :key="1" :form.sync="userForm" >
          <wt-form-table-list :key="1"  slot="wtFormTableList" :form.sync="userForm">
            <template slot="cover" slot-scope="data">
              <img class="table-img" v-if="data.row.cover && data.row.cover.length > 0" :src="imgUrl + data.row.cover.split(',')[0]">
            </template>
           </wt-form-table-list>
        </wt-form-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleDialogClose">取 消</el-button>
        <el-button size="small" type="primary" @click="handleDailogChoose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Message-edit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_MESSAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/message/messageUpdate',
      formAddUrl: '/modules/message/messageAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '消息推送标题', key: 'title', type: 'text', required: true, disabled: false },
          { name: '消息推送内容',
            key: 'content',
            type: 'textarea',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 500, message: '消息推送内容长度不能超过500', trigger: 'blur' }
            ] },
          { name: '消息推送类型', key: 'type', type: 'custom', required: true, disabled: false },
          { name: '消息推送人员', key: 'userIdList', type: 'custom', required: false, disabled: false }]
      },
      dialogVisible: false,
      userForm: { //  表单数据
        isFormLoading: false,
        formComponent: { list: { type: 'default', value: '/modules/userWechat/userWechatList' }},
        formInputsData: [{ name: '搜索用户', key: 'keyWord', value: '', type: 'text' }],
        formButtonsData: [],
        formTableData: [
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '用户名', key: 'name', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonHidden: true }
      },
      chooseData: []
    }
  },
  created() {
    console.log(this.detailFormData)
    if (this.componentType === 'add') {
      // this.looperTypeChange(this.detailFormData.looperType)
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddMessageDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateMessageDetail()
      }).catch(() => {
      })
    },
    handleDialogClose() {
      this.dialogVisible = false
    },
    handleDailogChoose() {
      if (this.userForm.formSelectedList && this.userForm.formSelectedList.length > 0) {
        const _chooseDataIds = []
        for (const item of this.chooseData) {
          _chooseDataIds.push(item.id)
        }
        for (const item of this.userForm.formSelectedList) {
          if (_chooseDataIds.indexOf(item.id) === -1) {
            this.chooseData.push(item)
          }
        }
      }
      this.dialogVisible = false
    },
    addUser() {
      this.dialogVisible = true
    },
    typeChange(val) {
      if (val === 1) {
        this.detailForm.elements[3].required = false
      }
      if (val === 2) {
        this.detailForm.elements[3].required = true
      }
    },
    toClickAction(row) {
      const _index = this.chooseData.indexOf(row)
      this.chooseData.splice(_index, 1)
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddMessageDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    requestUpdateMessageDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isMessageDetailLoading: state => state.message.isMessageDetailLoading,
      detailFormData: state => state.message.messageDetailData
    })
  },
  watch: {
    chooseData(val) {
      const _chooseDataIds = []
      for (const item of val) {
        _chooseDataIds.push(item.id)
      }
      this.detailFormData.userIdList = _chooseDataIds
    }
  }
}
</script>

